// extracted by mini-css-extract-plugin
export var dividerLine = "_6b-3";
export var itemImage = "_6b-9";
export var lightDivider = "_6b-4";
export var modalContent = "_6b-5";
export var modalContentCompact = "_6b-6";
export var productCard = "_6b-a";
export var productImage = "_6b-b";
export var productImageCompact = "_6b-7";
export var productImagePlaceholder = "_6b-c";
export var productImagePlaceholderCompact = "_6b-8";
export var progressBarBackground = "_6b-1";
export var progressBarContainer = "_6b-0";
export var progressBarFill = "_6b-2";